<!-- @format -->

<rules-tag>
  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item"><h1 class="heading-01 heading_terms">利用規約</h1></li>
    </ul>
    
  </div><!--/.container_breadcrumb-->
  
  <div class="contents">
    
    <section class="contents_area">
      <div class="contents_block detail" is="rules-content-tag"></div>
    </section><!--/.contents_area-->
    
  </div><!--/.contents-->

<script>
  import rulesTag from '@tags/parts/edilent-worker-rules.riot';
  export default {
    components: {
      "rules-content-tag": rulesTag
    }
  }
</script>
</rules-tag>
